module.exports = {"430304001":"岳塘街道","430304002":"东坪街道","430304004":"书院路街道","430304005":"下摄司街道","430304006":"建设路街道","430304008":"五里堆街道","430304010":"宝塔街道","430304014":"霞城街道","430304015":"荷塘街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430304.json
// module id = 1950
// module chunks = 0